import api from '@/api/api_pesquisa'
import Vue from 'vue'
import { asyncLoading } from 'vuejs-loading-plugin'
import VueLoading from 'vuejs-loading-plugin'


Vue.use(VueLoading, {
    dark: true, // default false
    text: 'Carregando', // default 'Loading'
    loading: false, // default false
    background: 'rgba(10,23,55,0.7)', // set custom background
})

export default {
  PESQUISAPLACASPG ({ commit }, {usuario, pesquisa, cidade, page, pagesize}) {
    let loading = new Promise(async (resolve, reject) =>{
      try {
        const info = await api.pesquisaplacaspg(usuario, pesquisa, cidade, page, pagesize)
        commit("PESQUISAPLACAPG", info )
        resolve(info)
      } catch (error) {
        reject(error)
      }
    })
    return asyncLoading(Promise.resolve(loading)).then().catch()
  },
  PESQUISAPLACASPGBK ({ commit }, {usuario, pesquisa, cidade, pagebk, pagesize}) {
    return new Promise(async (resolve, reject) =>{
      try {
        const info = await api.pesquisaplacaspg(usuario, pesquisa, cidade, pagebk, pagesize)
        commit("PESQUISAPLACAPGBK", info )
        resolve(info)
      } catch (error) {
        reject(error)
      }
    })
  },
  PESQUISAQTDPLACAS ({ commit }, {usuario, pesquisa, cidade}) {
    let loading = new Promise(async (resolve, reject) =>{
      try {
        const info = await api.pesquisaqtdplacas(usuario, pesquisa, cidade)
        commit("PESQUISAQTDPLACAS", info )
        resolve(info)
      } catch (error) {
        reject(error)
      }
    })
    return asyncLoading(Promise.resolve(loading)).then().catch()
  },
  BUSCARADARES ({ commit }, {cidade}) {
    let loading = new Promise(async (resolve, reject) =>{
      try {
        const info = await api.buscaradares(cidade)
        commit("BUSCARADAR", info )
        resolve(info)
      } catch (error) {
        reject(error)
      }
    })
    return asyncLoading(Promise.resolve(loading)).then().catch()
  },
  BUSCACORPORACOES ({ commit }, {cidade}) {
    return new Promise(async (resolve, reject) =>{
      try {
        const info = await api.buscacorporacoes(cidade)
        commit("BUSCACORPORACAO", info )
        resolve(info)
      } catch (error) {
        reject(error)
      }
    })
  },
  BUSCAIMAGEM ({ commit }, {filenameP, filenameZ, cidade}) {
    return new Promise(async (resolve, reject) =>{
      try {
        const infoP = await api.buscaimagem(filenameP, cidade)
        const infoZ = await api.buscaimagem(filenameZ, cidade)
        commit("BUSCAIMAGEMP", infoP )
        commit("BUSCAIMAGEMZ", infoZ )
        resolve(infoP)
        resolve(infoZ)
      } catch (error) {
        reject(error)
      }
    })
  },
  SALVARIMAGEM ({ commit }, {usuario, clientinfo, cidade, nomeImagem}) {
    return new Promise(async (resolve, reject) =>{
      try {
        const info = await api.salvarimagem(usuario, clientinfo, cidade, nomeImagem)
        commit("SALVARIMAGEM", info )
        resolve(info)
      } catch (error) {
        reject(error)
      }
    })
  },
  //PESQUISALPRBOTBACKEND ({ commit }, {valor, cidade}) {
  //  return new Promise(async (resolve, reject) =>{
  //    try {
  //      const info = await api.pesquisalprbotbackend(valor, cidade)
  //      commit("PESQUISALPRBOTBACKEND", info )
  //      resolve(info)
  //    } catch (error) {
  //      reject(error)
  //    }
  //  })
  //},
  
}